import { ConfluenceScope } from './types';

export const defaultPermissionsSupplier: () => Promise<ConfluenceScope[]> = () => {
	const response = Object.values(ConfluenceScope);
	return Promise.resolve(response);
};
